// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-io[data-v-5605f672]{width:100%;padding:24px 16px;border-radius:8px;background:#372059;border:1px solid #4a3669}.review-io__star[data-v-5605f672]{height:28px;width:28px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
